<div class="about">
  <img src="assets/images/aboutusimage.png" alt="item.name"
    style="border-radius: 100px;box-shadow: 0px 0px 44px 12px white;">
  <h2>About Us</h2>
  <p style="font-size: small;">
    Welcome to our food catering service! We are dedicated to providing delicious and high-quality meals for all your
    events.
    Our team of expert chefs uses only the freshest ingredients to create a wide variety of dishes that will satisfy
    every palate.
    Mr. Rajdeep Maity- an alumni of IHM Taratala &amp; the founder of “Spicetrail- Premium Catering
    Services” believed that It is our responsibility to understand that food is more than just sustenance;
    it&#39;s an experience. As per his vision, we became passionate about crafting exquisite culinary delights
    that tantalize your taste buds and leave a lasting impression. Our team of skilled chefs and dedicated
    professionals are committed to providing impeccable service, personalized menus, and flawless
    execution for every event, from intimate gatherings to grand celebrations. We use only the finest
    and the freshest ingredients to create dishes that are both visually stunning and incredibly
    flavourful.</p>
  <p style="font-size: small;">
    We also understood that busy professionals need convenient and delicious meal options. That&#39;s why
    we offer a reliable food delivery service that gives fresh, high-quality meals with sustainable &amp;
    efficient packaging directly to their doorstep. Our diverse menu caters to various tastes and dietary
    needs, ensuring something for everyone. We prioritize on-time delivery, excellent customer service,
    and always stick to our commitment to use freshly procured ingredients regularly. Experience the
    convenience of “Spicetrail
  </p>
  <p>
    Contact us today to learn more about our catering services and to customize a menu that suits your needs.
  </p>
</div>